import { embedded } from './config';

export function useScrollToTop() {
    if (!embedded) return;

    const scrollToTop = window.parent.document.getElementById(
        'react-scroll-to-top'
    );
    if (!scrollToTop) return;

    scrollToTop.classList.add('react-scroll-to-top-enabled');
}
